import { useSelector } from 'react-redux'
import { AppState } from '../../state'

export function useWalletState(): AppState['wallet'] {
  return useSelector((state: AppState) => state.wallet)
}
